
import { Link, useParams } from 'react-router-dom'
import classes from './PatientListVerticalItem.module.css'
import VerificationBoxCustom from './VerificationBoxCustom'
import PatientOrChart from '../page/PatientOrChart'

const INS_BOXES = [
    {
        id: 1,
        type: 'atty'
    },
    {
        id: 2,
        type: 'liability'
    },
    {
        id: 3,
        type: 'medpay'
    },
    {
        id: 4,
        type: 'um'
    },
    {
        id: 5,
        type: 'majormed'
    }
]

const PatientListVerticalItem = ({data, isVerification}) => {
    const params = useParams()

    return <li className={classes.list_item}>
        <Link to={`../${data.patient.person_number}`} className={`${classes.list_item_button} ${data.patient.person_number == params.patientId ? classes.list_item_button_active : ''}`}>

            <div className={classes.list_item_detail}>
                <div className="flex-container">
                    <PatientOrChart item={data}/>
                    <div className={classes.list_item_name}>{data.patient.name}</div>
                </div>
                <div className={classes.flex_wrapper}>
                    <div className={classes.list_item_case}>NG{data.patient.person_number}</div>
                    {isVerification && <div className={classes.list_item_boxes}>
                        {INS_BOXES && INS_BOXES.map(item => (
                            <VerificationBoxCustom key={item.id} rowData={data} type={item.type}/>
                        ))}
                        
                    </div>}
                </div>
            </div>
            
        </Link>
    </li>
}

export default PatientListVerticalItem